import { Github, Linkedin, Twitter, Terminal } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";
import { useLang } from "@/i18n/LanguageContext";

const LINK_IDS = ["hizmetler", "teknolojiler", "projeler", "surec", "iletisim"];

const SOCIALS = [
  { icon: Github, label: "GitHub", href: "https://github.com" },
  { icon: Linkedin, label: "LinkedIn", href: "https://linkedin.com" },
  { icon: Twitter, label: "Twitter / X", href: "https://x.com" },
];

export default function Footer() {
  const { t, lang } = useLang();
  const privacyPath = lang === "tr" ? "/privacy-policy" : `/${lang}/privacy-policy`;
  return (
    <footer className="border-t border-white/10 bg-[#191C22]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-md glow-badge flex items-center justify-center">
                <Terminal size={16} />
              </span>
              <span className="font-heading font-black text-xl tracking-tighter text-white">
                CDN BİLİŞİM<span className="text-[#5B7FFF]">.</span>
              </span>
            </div>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-sm">{t.footer.desc}</p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold text-slate-500 uppercase tracking-widest mb-5">{t.footer.quick_links}</h4>
            <ul className="flex flex-col gap-3">
              {LINK_IDS.map((id) => (
                <li key={id}>
                  <button
                    onClick={() => scrollToId(id)}
                    className="text-sm text-slate-400 hover:text-[#5B7FFF] transition-colors"
                    data-testid={`footer-link-${id}`}
                  >
                    {t.nav[id]}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-semibold text-slate-500 uppercase tracking-widest mb-5">{t.footer.social}</h4>
            <div className="flex gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-10 h-10 rounded-lg glass-card flex items-center justify-center text-slate-400 hover:text-[#5B7FFF] hover:border-[#5B7FFF]/40 transition-colors duration-200"
                  data-testid={`footer-social-${s.label.toLowerCase().replace(/[^a-z]/g, "")}`}
                >
                  <s.icon size={18} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} CDN Bilişim. {t.footer.rights}</p>
          <div className="flex gap-6">
            <Link to={privacyPath} className="text-xs text-slate-500 hover:text-slate-300 transition-colors" data-testid="footer-privacy-link">
              {t.footer.privacy}
            </Link>
            <Link to="/kvkk" className="text-xs text-slate-500 hover:text-slate-300 transition-colors" data-testid="footer-kvkk-link">
              {t.footer.kvkk}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
